import {ManagementBadge} from "../pages/profile-page/config/management-badge";
import {MemberData} from "../pages/profile-page/config/member-data";

export class ManagementBadgeStatistic {

  badge: ManagementBadge;
  members: MemberData[];

}
